var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZohoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    preserveAspectRatio: "xMidYMid",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 55.995,
    y1: 21.402,
    x2: 55.995,
    y2: 135.011,
    id: "A",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ffe513",
    offset: ".5618%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fdb924",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 5.814,
    y1: 43.409,
    x2: 117.212,
    y2: 132.87,
    id: "B",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008cd2",
    offset: ".5618%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00649d",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 75.602,
    y1: 73.54,
    x2: 75.602,
    y2: 173.074,
    id: "C",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26a146",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#008a52",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 54.23,
    y1: 48.781,
    x2: 71.354,
    y2: 152.129,
    id: "D",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#d92231",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ba2234",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.125 0 0 .125 0 20.9625)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512 37.7v121.4l-16.8 16.4V56.7z",
    fill: "#e79225"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9 37.8l-17.4 18.9.9 1.2 109.1-.4 1-.8 16.5-19z",
    fill: "#fff16d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.5 19.7h111v118.9H.5z",
    fill: "url(#A)",
    transform: "translate(384 37)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478.6 99.5c-2.2-5.5-5.5-10.5-9.8-14.8-4.1-4.2-8.7-7.4-13.9-9.5-5.1-2.1-10.6-3.2-16.6-3.2s-11.6 1.1-16.7 3.2c-5.2 2.1-9.8 5.3-13.9 9.5-4.3 4.3-7.5 9.3-9.7 14.8s-3.2 11.5-3.2 18.1c0 6.4 1.1 12.4 3.3 18a44.49 44.49 0 0 0 9.7 15c4 4.1 8.6 7.2 13.7 9.3s10.8 3.2 16.9 3.2c5.9 0 11.4-1.1 16.5-3.2s9.8-5.2 13.9-9.3c4.3-4.4 7.6-9.4 9.8-14.9s3.3-11.6 3.3-18c0-6.7-1.1-12.7-3.3-18.2zm-22.9 39.2c-4.3 5.1-10 7.7-17.4 7.7s-13.2-2.6-17.5-7.7-6.4-12.2-6.4-21.2c0-9.2 2.2-16.3 6.4-21.5 4.3-5.2 10-7.7 17.5-7.7 7.4 0 13.1 2.6 17.4 7.7 4.2 5.2 6.4 12.3 6.4 21.5 0 9-2.1 16.1-6.4 21.2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6 27.8v.6l14.2 109.1-8.3 23-1.1-.8-14.6-104.6.3-1.4 9.1-25.3z",
    fill: "#009ada"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.3 43l109.3-15.2-9.2 26.2-1.3 1.4-102.2 15 .5-18.7z",
    fill: "#91c9ed"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.4 27l15.1 106.5-107.7 15.1L.3 45.7l6.3-4.9z",
    fill: "url(#B)",
    transform: "translate(257 27)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.1 74.4c-.5-3.3-1.6-5.8-3.4-7.5-1.5-1.3-3.3-2-5.4-2-.5 0-1.1 0-1.7.1-2.8.4-4.9 1.7-6.2 3.8-1 1.5-1.4 3.4-1.4 5.6 0 .8.1 1.7.2 2.6l3.9 27.7-31 4.6-3.9-27.7c-.5-3.2-1.6-5.7-3.4-7.4-1.5-1.4-3.3-2.1-5.3-2.1-.5 0-1 0-1.5.1-2.9.4-5.1 1.7-6.5 3.8-1 1.5-1.4 3.4-1.4 5.6 0 .8.1 1.7.2 2.7l10.6 72.1c.5 3.3 1.6 5.8 3.6 7.5 1.5 1.3 3.3 1.9 5.5 1.9.6 0 1.2 0 1.8-.1 2.7-.4 4.7-1.7 6-3.8.9-1.5 1.3-3.3 1.3-5.4 0-.8-.1-1.7-.2-2.6l-4.3-28.5 31-4.6 4.3 28.5c.5 3.3 1.6 5.8 3.5 7.4 1.5 1.3 3.3 2 5.4 2 .5 0 1.1 0 1.7-.1 2.8-.4 4.9-1.7 6.2-3.8.9-1.5 1.4-3.3 1.4-5.5 0-.8-.1-1.7-.2-2.6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 0l-38.9 92.4 5.3 40.6.3-.1 43.7-98.3-.2-2.1-9.4-31.2z",
    fill: "#66bf6b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162 0l10.3 34.6 96.2 43.1.3-.2-8.2-32.4z",
    fill: "#98d0a0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.1 33.9l96.7 43.6-43.7 99.1L5.4 133z",
    fill: "url(#C)",
    transform: "translate(123)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.5 85.5c-2.1-5.6-5-10.4-8.8-14.4s-8.4-7.2-13.8-9.5-10.8-3.4-16.3-3.4h-.3c-5.6 0-11.1 1.3-16.5 3.7-5.7 2.5-10.6 5.9-14.8 10.4-4.2 4.4-7.6 9.8-10.2 16-2.6 6.1-4 12.3-4.3 18.4v2.1c0 5.4.9 10.7 2.8 15.9 2 5.5 4.9 10.2 8.7 14.2s8.5 7.2 14.1 9.5c5.3 2.3 10.7 3.4 16.2 3.4h.1c5.5 0 11-1.2 16.4-3.5 5.7-2.5 10.7-6 14.9-10.5 4.2-4.4 7.7-9.7 10.3-15.9s4-12.3 4.3-18.4v-1.8c.1-5.5-.8-10.9-2.8-16.2zm-19.3 28.8c-3.6 8.6-8.5 14.5-14.4 17.7-3.2 1.7-6.5 2.6-9.8 2.6-2.9 0-6-.7-9.1-2-6.8-2.9-11-7.5-12.8-14.1-.6-2.2-.9-4.5-.9-6.9 0-4.8 1.2-10.1 3.6-15.8 3.7-8.8 8.6-14.8 14.5-18.1 3.2-1.8 6.5-2.6 9.8-2.6 3 0 6 .7 9.2 2 6.7 2.9 10.9 7.5 12.7 14.1.6 2.1.9 4.4.9 6.8 0 5-1.2 10.4-3.7 16.3z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.4 15.7l15.8 105.8-7.2 37.2-1-1.3-15.4-102.2v-2l6.8-35.7z",
    fill: "#760d16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 70.4L7.5 33l107.9-17.3-7.3 38.1v2.5L1.3 71.4z",
    fill: "#ef463e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.1 38.8L124 143.7 17.2 160.4 0 55.4z",
    fill: "url(#D)",
    transform: "translate(0 15)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6 142c-.8-1-2-1.7-3.4-2.2s-3.1-.7-5.2-.7c-1.9 0-4.1.2-6.5.6l-28.2 4.8c.3-2.2 1.4-5 3.3-8.5 2.1-3.9 5.3-8.6 9.4-14a133.09 133.09 0 0 1 3.3-4.3c.5-.7 1.3-1.6 2.3-2.9 6.5-8.5 10.4-15.4 12-20.8.9-3.1 1.4-6.2 1.6-9.3.1-.9.1-1.7.1-2.5 0-2.2-.2-4.4-.6-6.6-.3-2-.8-3.6-1.5-4.9s-1.5-2.3-2.5-2.9c-1.1-.7-2.8-1-4.9-1-1.7 0-3.8.2-6.3.6L36.9 73c-3.9.7-6.9 1.8-8.7 3.6-1.5 1.4-2.2 3.2-2.2 5.2 0 .5 0 1.1.1 1.7.5 2.8 1.9 4.8 4.2 5.8 1.4.6 3 .9 5 .9 1.3 0 2.8-.1 4.4-.4L66.9 85c0 .5.1 1 .1 1.4a14.26 14.26 0 0 1-.9 5c-.8 2.3-2.8 5.5-6.1 9.6l-4.2 5.2c-7.4 8.9-12.6 16.5-15.8 22.8-2.3 4.4-3.8 8.6-4.7 12.9-.5 2.5-.8 4.8-.8 7.1 0 1.6.1 3.2.4 4.7.4 2.2.9 4 1.6 5.4s1.7 2.5 2.8 3.1 2.6.8 4.8.8c2.7 0 6.4-.4 11.1-1.2l29.6-5.1c5.2-.9 8.9-2.2 11-3.9 1.7-1.4 2.6-3.3 2.6-5.5 0-.6-.1-1.2-.2-1.8-.2-1.3-.7-2.5-1.6-3.5z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZohoIcon);
export default __webpack_public_path__ + "static/media/zoho_icon.2168d7bd5418a54306b0b0fd1449dd0a.svg";
export { ForwardRef as ReactComponent };